import { createStore, applyMiddleware } from 'redux';
import { createLogger } from 'redux-logger';
import thunk from 'redux-thunk';
import rootReducer from '../reducers';
import socketMiddleware from '../socket/socketMiddleware';

const logger = createLogger();

export default function configureStore(socketClient) {
    let middlewares = [thunk, socketMiddleware(socketClient)];

    if (process.env.NODE_ENV !== 'production') {
      middlewares = [...middlewares, logger];
    }

    const store = createStore(
        rootReducer,
        applyMiddleware(thunk, ...middlewares)
        
    );

    return store;
}



// WEBPACK FOOTER //
// ./source/config/store.js